export default __webpack_public_path__ + "static/media/photo--sm--59.b0b85b57.jpg";